import { type BaseDto } from "@pasta/box-v2";
import { type LetterFileDocumentDto } from "./letter-file-document.dto";

export enum DocumentVersionModifiedSource {
  ORIGINAL_UPLOAD = "original_upload",
  SIGN = "sign",
  PADES = "pades",
  WOPI = "wopi",
  REPLACE = "replace",
  K2000 = "k2000",
}

export interface DocumentVersionDto extends BaseDto {
  author: string;
  document?: LetterFileDocumentDto;
  extension?: string;
  modifiedSource: DocumentVersionModifiedSource;
}
